import { render } from "./EnSandwich.vue?vue&type=template&id=0d8a8f46&scoped=true"
import script from "./EnSandwich.vue?vue&type=script&lang=js"
export * from "./EnSandwich.vue?vue&type=script&lang=js"

import "./EnSandwich.vue?vue&type=style&index=0&id=0d8a8f46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d8a8f46"]])

export default __exports__